<form *ngIf="fields" [formGroup]="addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="saveOrUpdate()" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid" >
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.code.nullable}">{{ fields.code.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="code" [maxlength]="fields.code.width" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.code"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.description.nullable}">{{ fields.description.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="description" [maxlength]="fields.description.width" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.description"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.time_range.nullable}">{{ fields.time_range.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" [maxlength]="fields.time_range.width" formControlName="time_range" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.time_range"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label>{{ 'calendarList.monday' | translate}}</label></div>
      <div class="ui-grid-col-8">
        <p-inputSwitch formControlName="monday"></p-inputSwitch>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label>{{ 'calendarList.tuesday' | translate}}</label></div>
      <div class="ui-grid-col-8">
        <p-inputSwitch formControlName="tuesday" value="1"></p-inputSwitch>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label>{{ 'calendarList.wednesday' | translate}}</label></div>
      <div class="ui-grid-col-8">
        <p-inputSwitch formControlName="wednesday" value="1"></p-inputSwitch>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label>{{ 'calendarList.thursday' | translate}}</label></div>
      <div class="ui-grid-col-8">
        <p-inputSwitch formControlName="thursday" value="1"></p-inputSwitch>
      </div>
    </div>
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label>{{ 'calendarList.friday' | translate}}</label></div>
      <div class="ui-grid-col-8">
        <p-inputSwitch formControlName="friday" value="1"></p-inputSwitch>
      </div>
    </div>
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label>{{ 'calendarList.saturday' | translate}}</label></div>
      <div class="ui-grid-col-8">
        <p-inputSwitch formControlName="saturday" value="1"></p-inputSwitch>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label>{{ 'calendarList.sunday' | translate}}</label></div>
      <div class="ui-grid-col-8">
        <p-inputSwitch formControlName="sunday" value="1"></p-inputSwitch>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label>{{ 'calendarList.extraOpen' | translate}}</label></div>
      <div class="ui-grid-col-8">
        <p-inputSwitch formControlName="flg_extra_open" value="1"></p-inputSwitch>
      </div>
    </div>

    <p-footer>
      <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
        <button  class="k-generic-btn" type="submit" pButton icon="fa fa-check"
                 label="{{dialogBoxCalendar.id ? ('common.edit' | translate) :  ('common.add' | translate) }} {{ 'calendarList.calendar' |translate }}"></button>
      </div>
    </p-footer>

  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/calendar/calendarForm.component.html